import apiClient from "./apiClient";

const studentApi = {
	getStudentsByDepartment: async (departmentId, token) => {
		const response = await apiClient.get(
			`/Student/department/${departmentId}`,
			{
				headers: { Authorization: `Bearer ${token}` },
			}
		);
		return response.data;
	},
};

export default studentApi;
